import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { BREADCRUMB_JOINED_SEPARATOR } from './DynamicFieldBreadcrumb.constants';
import { breadcrumbPrefixStyles, breadcrumbStyles } from './DynamicFieldBreadcrumb.styles';

const DynamicFieldBreadcrumb = ({ path }) => {
  if (!path?.length) {
    return null;
  }

  const lastSegment = path[path.length - 1];
  const prefixSegments = path.slice(0, -1);
  const prefixText = prefixSegments.length
    ? `${prefixSegments.join(BREADCRUMB_JOINED_SEPARATOR)}${BREADCRUMB_JOINED_SEPARATOR}`
    : '';

  return (
    <Box sx={breadcrumbStyles}>
      {!!prefixText && (
        <Typography color="text.secondary" sx={breadcrumbPrefixStyles} variant="regular12">
          {prefixText}
        </Typography>
      )}
      <Typography color="text.primary" variant="bold12">
        {lastSegment}
      </Typography>
    </Box>
  );
};

DynamicFieldBreadcrumb.propTypes = {
  path: PropTypes.arrayOf(PropTypes.string),
};

export default DynamicFieldBreadcrumb;
